import { Controller } from "@hotwired/stimulus";

// TODO: find a way to test this class. It will involve a fake timer. 
export default class ToastController extends Controller<HTMLElement> {

    static values = {delay: Number, fade: Number};

    /** Number of milliseconds before the toast starts to fade */
    declare delay: number;
    
    /** Number of milliseconds the toast takes to fade */
    declare fade: number;

    connect(): void {
        setTimeout(() => this.hide(), this.delay);
    }

    hide(): void {
        this.element.style.opacity = '0';
        setTimeout(() => this.element.remove(), this.fade);
    }
}
